import { useContext, useEffect, useState } from 'react'
import { LegacyAntdModal } from 'components/LegacyAntdModal/LegacyAntdModal'
import { observer } from 'mobx-react-lite'

import { SystemContext } from 'stores/System'
import Styles from './SafariBraveWSModal.module.scss'
import { ReactComponent as CloseIcon } from 'assets/icons/close24.svg'
import { CollabStateContext } from 'stores/CollabState'
import { ConnectionStatus, StateSyncStatus } from '../utils'

export const SafariBraveWSModal = observer(function SafariBraveWSModal() {
  const system = useContext(SystemContext)
  const collabState = useContext(CollabStateContext)
  const isSafariOrBrave = system.isSafari || system.isBrave
  const wsDisconnected =
    collabState?.connStatus === ConnectionStatus.LongConnecting && collabState?.saveStatus !== StateSyncStatus.Behind
  const [visible, setVisible] = useState(isSafariOrBrave && wsDisconnected)

  useEffect(() => {
    if (isSafariOrBrave && wsDisconnected) {
      setVisible(true)
    }
  }, [isSafariOrBrave, wsDisconnected])

  return (
    <LegacyAntdModal
      visible={visible}
      onCancel={() => setVisible(false)}
      wrapClassName={Styles.container}
      closable={false}
      width={650}
    >
      <div className={Styles.header}>
        <h2>It looks like there's an issue with your browser</h2>
        <button className={Styles.closeButton} onClick={() => setVisible(false)} aria-label="close modal">
          <CloseIcon aria-hidden="true" />
        </button>
      </div>
      <div className={Styles.body}>
        <p>
          We're having a hard time connecting to our server, this could be due to a known{' '}
          <a href="https://bugs.webkit.org/show_bug.cgi?id=228296" target="_blank" rel="noreferrer nofollow noopener">
            Safari
          </a>{' '}
          or{' '}
          <a
            href="https://github.com/brave/brave-browser/issues/15410"
            target="_blank"
            rel="noreferrer nofollow noopener"
          >
            Brave
          </a>{' '}
          issue.
        </p>
        <p>
          <b>Please restart your browser to restore your connection.</b>
        </p>
      </div>
    </LegacyAntdModal>
  )
})
